import { Movie } from '../models/movie';

const shortMovies: Movie[] = [
  {
    id: "Imagefilm-Fw",
    name: "Imagefilm Feuerwehr Untere Emme",
    dates: {
      published: new Date("2023-12-10")
    },
    links: {
      movie: "https://www.youtube.com/embed/q4b_dzUqaVw?si=UVMEf7jtDmltIGpk",
    }
  },
  {
    id: "Komfortzone",
    name: "Komfortzonä",
    dates: {
      published: new Date("2024-01-14")
    },
    links: {
      movie: "https://www.youtube.com/embed/3o_0aQc_L2c?si=O6l-XAipvj9UAHoX",
    }
  },
  {
    id: "Tunesien",
    name: "Tunesien",
    dates: {
      published: new Date("2026-03-26")
    },
    links: {
      movie: "https://www.youtube.com/embed/HrPG8ljDTbY?si=-IrnVpfx_xgMbYu4",
    }
  }
];

export function getShortMovies(): Movie[] {
  return shortMovies;
}